import { CompanyDto } from "../main";

export class CreatedOkvedPartitionDto {
  partitionCode: string;
  name: string;
}

export class OkvedPartitionDto extends CreatedOkvedPartitionDto {
  id: number;
}

export declare class CreatedOkvedGroupDto {
  okvedId: number;
  code: string;
  name: string;
}

export declare class OkvedGroupDto extends CreatedOkvedGroupDto {
  id: number;
}

export declare class OkvedCompanyDto {
  id: number;
  companyId: number;
  okvedId: number;
  company: CompanyDto;
  group: OkvedGroupDto;
  partition: OkvedPartitionDto;
}

export declare class OkvedInfoDto {
  id: number;
  code: string;
  name: string;
}